import { render, staticRenderFns } from "./TaskDocumentsBody.vue?vue&type=template&id=7ed1a34e&scoped=true&"
import script from "./TaskDocumentsBody.vue?vue&type=script&lang=js&"
export * from "./TaskDocumentsBody.vue?vue&type=script&lang=js&"
import style0 from "./TaskDocumentsBody.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TaskDocumentsBody.vue?vue&type=style&index=1&id=7ed1a34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed1a34e",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QItemSection,QIcon,QBadge,QTooltip,QBtn,QExpansionItem,QTr,QTd,QBanner,QField,QToggle,QCheckbox,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QItemSection,QIcon,QBadge,QTooltip,QBtn,QExpansionItem,QTr,QTd,QBanner,QField,QToggle,QCheckbox}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
